import Mslogo from '../../../../assets/images/Microsoft_logo.png';
import Image from '../../Image';
import styles from './styles';

export default function MicrosoftAuthCardImage({...props}) {
    return <Image src={Mslogo} sx={styles.MicrosoftAuthCardImage} {...props} />;
}
